import { AxiosReportLas, AxiosGlobalFilters } from '../config';
import qs from 'qs';
import { applyArrayFilter } from 'utils/applyArrayFilter';

const QRcodeService = {
  getQRcode: objs => {
    const { empresa, tipoEquipamento, unidades, grupoArea } = objs;
    return AxiosReportLas({
      method: 'post',
      url: '/v1/Listagem/ListagemEquipamentos',
      data: {
        empresa,
        tipoEquipamento,
        unidades,
        grupoArea,
      },
      headers: {
        'content-type': 'application/json',
      },
    });
  },

  // MARINERS-1983 (B4): consumo de GET /v1/etiquetas — substitui getQRCodeEquipamentosAtivos/
  // getQRCodeAreasAtivas (removidos aqui, sem consumidor restante após a migração — provado
  // por grep antes de remover) para o dataset de geração dos 3 tipos de etiqueta. Teto de
  // PageSize é 500 no backend (MaxPageSize em EtiquetasController.cs — DIFERENTE do teto do
  // legado, 100; não assumir igual, confirmado ao vivo em Homolog: P1 do PR).
  // `tipo` aceita 'equipamento' | 'area' | 'unidade'. Resposta: { items, pageIndex, pageSize,
  // totalCount } — paginação real (totalCount vem pronto, não se descobre por página vazia).
  getEtiquetas: ({
    tipo,
    empresaId,
    unidadeId,
    grupoAreaId,
    subGrupoAreaId,
    areaId,
    equipamentoId,
    grupoEquipamentoId,
    tipoEquipamentoId,
    sistemaId,
    fornecedorEquipamentoId,
    planoAtividadeId,
    search,
    pageIndex = 1,
    pageSize = 500,
  }) => {
    const params = { tipo, pageIndex, pageSize };
    const headers = { EmpresaId: empresaId };

    // P3 (decisão do PR): GrupoUnidadeId/SubGrupoUnidadeId NÃO são enviados de propósito —
    // hoje só estreitam o dropdown de Unidade no form (nunca chegaram ao backend); o backend
    // já os aplica de verdade se enviados, então mandar mudaria o resultado da geração pra
    // quem tem esses filtros configurados. Preserva o comportamento atual.
    applyArrayFilter(params, unidadeId, 'unidadeId');
    applyArrayFilter(params, grupoAreaId, 'grupoAreaId');
    applyArrayFilter(params, subGrupoAreaId, 'subGrupoAreaId');
    applyArrayFilter(params, areaId, 'areaId');
    applyArrayFilter(params, equipamentoId, 'equipamentoId');
    applyArrayFilter(params, grupoEquipamentoId, 'grupoEquipamentoId');
    applyArrayFilter(params, fornecedorEquipamentoId, 'fornecedorEquipamentoId');
    applyArrayFilter(params, planoAtividadeId, 'planoAtividadeId');
    if (tipoEquipamentoId) params.tipoEquipamentoId = tipoEquipamentoId;
    if (sistemaId) params.sistemaId = sistemaId;
    if (search) params.search = search;

    return AxiosGlobalFilters({
      method: 'get',
      url: '/v1/etiquetas',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  getQRCodeUnidadesAtivas: ({
    empresaId,
    unidadeId,
    usuarioTipo,
    usuarioId,
    grupoUnidadeIds,
    subGrupoUnidadeIds,
    estadoId,
    cidadeId,
    codigo,
    grupoUnidadeId,
    subGrupoUnidadeId,
    pageSize = 1000,
    pageIndex = 1,
  }) => {
    const headers = {
      EmpresaId: empresaId,
      UnidadeId: unidadeId,
    };
    const params = {
      PageSize: pageSize,
      PageIndex: pageIndex,
    };

    if (usuarioTipo) params.UsuarioTipo = usuarioTipo;
    if (usuarioId) params.UsuarioId = usuarioId;
    applyArrayFilter(params, grupoUnidadeIds, 'GrupoUnidadeIds');
    applyArrayFilter(params, subGrupoUnidadeIds, 'SubGrupoUnidadeIds');
    if (estadoId) params.EstadoId = estadoId;
    if (cidadeId) params.CidadeId = cidadeId;
    if (codigo) params.Codigo = codigo;
    if (grupoUnidadeId) params.GrupoUnidadeId = grupoUnidadeId;
    if (subGrupoUnidadeId) params.SubGrupoUnidadeId = subGrupoUnidadeId;
    if (grupoUnidadeId) params.grupoUnidadeId = grupoUnidadeId;
    if (subGrupoUnidadeId) params.subGrupoUnidadeId = subGrupoUnidadeId;

    return AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/unidades/ativas',
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
      headers,
    });
  },

  // MARINERS-1949 v2: detalhe de UMA unidade por id (site, nome, logomarcaPath...). Usado p/
  // buscar só as unidades selecionadas na Etiqueta de Unidade, sem baixar todas via /ativas
  // (que ignora o filtro de unidade E a paginação).
  getQRCodeUnidadeById: ({ empresaId, unidadeId }) =>
    AxiosGlobalFilters({
      method: 'GET',
      url: `/v1/unidades/${unidadeId}`,
      headers: { EmpresaId: empresaId },
    }),
};

export { QRcodeService };
